import Joi from 'joi';

export default (key: any): boolean => {
  const result = Joi.string().isoDate().validate(key);
  return !!!result?.error && key.length > 24 && key.length < 26;
};
